module.exports = __webpack_public_path__ + "img/100.85bcf329.jpg";